import { useState, useCallback, useRef } from 'react';
import { wasGlobalErrorShownRecently } from '../utils/globalNotifier';

export function useNotification() {
  const [notification, setNotification] = useState(null);
  const timerRef = useRef(null);

  const show = useCallback((message, type = 'success') => {
    // An access-denied API response already showed its own specific message via the
    // global notification bar (see api/api.js + globalNotifier.js) — skip this page's
    // own generic error toast so the two don't stack on top of each other.
    if (type === 'error' && wasGlobalErrorShownRecently()) return;
    // Clear any existing auto-dismiss timer before showing a new message
    if (timerRef.current) clearTimeout(timerRef.current);
    setNotification({ message, type });
    timerRef.current = setTimeout(() => setNotification(null), 4000);
  }, []);

  const NotificationBar = () => notification ? (
    <div className={`notification notification-${notification.type}`}>
      <span>{notification.type === 'success' ? '✓' : '✕'}</span>
      {notification.message}
    </div>
  ) : null;

  return { show, NotificationBar };
}
